"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useRouter } from "next/router";
function scrollToTop() {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}
function scrollToHash(hash, smooth) {
  if (!hash) return false;
  const id = decodeURIComponent(hash.split("?")[0]);
  const el = document.getElementById(id);
  if (!el) return false;
  el.scrollIntoView({
    behavior: smooth ? "smooth" : "auto",
    block: "start"
  });
  return true;
}
export default function ScrollManager() {
  const $ = _c(4);
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  let t1;
  let t2;
  if ($[1] !== router.events) {
    t1 = () => {
      const onRouteStart = _temp2;
      const onRouteComplete = _temp3;
      const onHashComplete = _temp4;
      router.events.on("routeChangeStart", onRouteStart);
      router.events.on("routeChangeComplete", onRouteComplete);
      router.events.on("hashChangeComplete", onHashComplete);
      return () => {
        router.events.off("routeChangeStart", onRouteStart);
        router.events.off("routeChangeComplete", onRouteComplete);
        router.events.off("hashChangeComplete", onHashComplete);
      };
    };
    t2 = [router.events];
    $[1] = router.events;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return null;
}
function _temp4(url_0) {
  const hash_0 = url_0.includes("#") ? url_0.split("#")[1]?.split("?")[0] : "";
  if (hash_0) {
    scrollToHash(hash_0, true);
  }
}
function _temp3(url) {
  const hash = url.includes("#") ? url.split("#")[1]?.split("?")[0] : "";
  if (hash) {
    requestAnimationFrame(() => {
      setTimeout(() => scrollToHash(hash, true), 0);
    });
  } else {
    scrollToTop();
    requestAnimationFrame(scrollToTop);
  }
}
function _temp2() {
  scrollToTop();
}
function _temp() {
  if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }
}